module.exports = __webpack_public_path__ + "static/media/baruch-logo-white.293289d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/baruch-logo-white.svg
// module id = 576
// module chunks = 0